import getFilters from 'components/Filters';
import MenteeStatusChip from 'components/Chips/MenteeStatusChip';
import MENTEE_STATUS, { MenteeStatusValues } from 'enums/MenteeStatus';
import MENTORSHIP_STATUS, { MentorshipStatusValues } from 'enums/MentorshipStatus';
import { FC, useContext } from 'react';
import useSWR from 'swr';
import MentorshipReferee from 'types/MentorshipReferee';
import { getIsMenteeStatus, menteeTags } from 'utils/menteeTags';
import { BinomesContext, TagColumnNames } from '..';

const Filters = getFilters<TagColumnNames>();
const BinomesFilters: FC = () => {
  const { search, setSearch, tags, setTags, take, setTake } =
    useContext(BinomesContext);

  const { data: referees } = useSWR<MentorshipReferee[]>('/mentorship-referee');

  return (
    <Filters
      tagList={[
        {
          columnName: 'status',
          columnTitle: 'Statut du mentorat',
          tags: menteeTags.map((tag) => {
            const isMenteeStatus = getIsMenteeStatus(tag);
            return {
              name: tag,
              label: isMenteeStatus
                ? MENTEE_STATUS[tag]
                : MENTORSHIP_STATUS[tag],
              labelComponent: (
                <MenteeStatusChip
                  status={
                    isMenteeStatus
                      ? (tag as MenteeStatusValues)
                      : 'MENTORSHIP_ACTIVE'
                  }
                  mentorshipStatus={
                    isMenteeStatus ? 'ONGOING' : (tag as MentorshipStatusValues)
                  }
                />
              ),
            };
          }),
        },
        {
          columnName: 'referee',
          columnTitle: 'Chargée de mentorat',
          tags:
            referees?.map((referee) => ({
              name: referee.name || '',
              label: `(Chargée) ${referee.name}`,
              labelComponent: referee.name || '',
            })) || [],
        },
      ]}
      state={{ tags, search, take }}
      setTags={setTags}
      setSearch={setSearch}
      setTake={setTake}
    />
  );
};

export default BinomesFilters;